import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTemperatureArrowUp, faTint, faDoorClosed, faDoorOpen, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { faLightbulb as faLightbulbSolid } from "@fortawesome/free-solid-svg-icons";
import { faLightbulb as faLightbulbRegular } from "@fortawesome/free-regular-svg-icons";
import { faGauge } from "@fortawesome/free-solid-svg-icons";
import { setEndpointValue } from "../../services/mqttService.js";



const ICON_CONFIGS = {
  temperature : [{ icon: faTemperatureArrowUp,   units: "C"  }],
  humidity    : [{ icon: faTint,                 units: "%"  }],
  voltage     : [{ icon: faGauge,                units: "V"  }],
  current     : [{ icon: faGauge,                units: "A"  }],
  button      : [
                  { icon: faDoorClosed,  threshold: 1, units: "" },
                  { icon: faDoorOpen,    threshold: 0, units: "" },
                ],
  door        : [
                  { icon: faDoorClosed,  threshold: 1, units: "" },
                  { icon: faDoorOpen,    threshold: 0, units: "" },
                ],                
  led         : [    
                  { icon: faLightbulbSolid,     threshold: 1, units: "" },
                  { icon: faLightbulbRegular,   threshold: 0, units: "" },
                ],
}

// Todo: Should the color change with the value? e.g. If temperature is too high, set it to red?
const colorClass = "text-blue";

/**
* Determines the icon and units based on type and value.
*/
const getIconAndUnits = (type, value) => {
  const config = ICON_CONFIGS[type] || { icon: faQuestionCircle, units: "" };

  const match =
    config.find(item =>
      item.threshold !== undefined && value >= item.threshold
    ) || config[0];

  return {
    icon: match.icon,
    units: match.units,
  };
}; 

const WidgetSlider = ({
  deviceId,
  displayTitle,  

  // Slider configuration
  min = 0,
  max = 100,
  step = 1,
  value = 0,
  
  type = "temperature", // default type
  endpoint = 1,

}) => {
  const [sliderValue, setSliderValue] = useState(value);
  const { icon, units } = getIconAndUnits(type, sliderValue);

  // set the slider value when the value prop changes
  useEffect(() => {
    setSliderValue(value);
  }, [value]);

  const handleSliderChange = (event) => {
    const newValue = Number(event.target.value);

    setSliderValue(newValue);
  };

  const handleSliderChangeComplete = async() => {
    try {
      await setEndpointValue (deviceId, endpoint, sliderValue);
    } catch (error) {
      console.error("Error setting endpoint value: ", error);
    }
  }

  return (
    <div className="widget-slider">
      
      {/* Header */}
      <div className="widget-header flex items-center space-x-2">
        <FontAwesomeIcon
          icon={icon}
          className={`fa-3x ${colorClass}`}
        />

        <div className="widget-title">
          {displayTitle}
        </div>
      </div>

      {/* Current Value */}
      <div className={`widget-warningcard-value ${colorClass}`}>
        {sliderValue} {units}
      </div>

      {/* Slider */}
      <div className="widget-slider-container">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={sliderValue}
          onChange={handleSliderChange}
          onMouseUp={handleSliderChangeComplete}
          onTouchEnd={handleSliderChangeComplete}
          className="widget-slider"
        />

        {/* Range Labels */}
        <div className="widget-slider-labels">
          <span>{min} - {max}</span>
        </div>
      </div>

    </div>
  );
};


WidgetSlider.propTypes = {
  deviceId: PropTypes.string.isRequired,
  displayTitle: PropTypes.string.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  value: PropTypes.number,
  type: PropTypes.string,
  endpoint: PropTypes.number,
};

export default WidgetSlider;